
class ObjectHelper {
  static keys (dotkey) {
    let keys = dotkey.split('.')
    let keyFirst = dotkey.split('.')
    let keyLast = keyFirst.pop()
    keyFirst = keyFirst.join('.')
    return {
      keys,
      keyFirst,
      keyLast
    }
  }

  static get (object, dotkey) {
    const getProp = (obj, prop) => {
      return prop.split('.').reduce((r, e) => {
        if (r === undefined || r === null) {
          return undefined
        }
        return r[e]
      }, obj)
    }
    return getProp(object, dotkey)
  }

  static excludeKeys (object, excludeKeys) {
    for (let k in excludeKeys) {
      let key = excludeKeys[k]
      if (object.hasOwnProperty(key)) {
        delete object[key]
      }
    }
    return object
  }

  static getMetaAttr (block, attrKey) {
    return block && block.meta && block.meta[attrKey]
  }
}

export default ObjectHelper
